var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    staticClass: "info-list"
  }, [_c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "list-bar-wrap"
  }, _vm._l(_vm.listBar, function (item) {
    return _c('div', {
      class: [item.isChecked ? 'list-bar-item-checked' : 'list-bar-item'],
      on: {
        "click": function ($event) {
          return _vm.changeListBar(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 0), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "basic-purview"
  }, [_vm.isShowInfo ? _c('div', {
    staticClass: "basic-info-wrap"
  }, [_c('div', {
    staticClass: "title-wrap"
  }, [_c('h3', [_vm._v("基础信息")]), _c('div', {
    staticStyle: {
      "color": "#858585",
      "cursor": "pointer"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.EditCustomerDetailDrawer.openDrawer(_vm.customer);
      }
    }
  }, [_vm._v(" 编辑 ")])]), _c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    staticClass: "basic-info-left"
  }, [_c('CustomerBasicInfoRow', {
    attrs: {
      "field": "法人代表",
      "value": _vm.customer.legalRep,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "网址",
      "value": _vm.customer.web,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "电话",
      "value": _vm.customer.phone,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "邮箱",
      "value": _vm.customer.email,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "所属省份",
      "value": _vm.customer.province,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "所属城市",
      "value": _vm.customer.city,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "所属区县",
      "value": _vm.customer.dist,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "信用代码",
      "value": _vm.customer.creditCode,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "公司类型",
      "value": _vm.customer.companyType,
      "type": 'string'
    }
  })], 1), _c('div', {
    staticClass: "basic-info-right"
  }, [_c('CustomerBasicInfoRow', {
    attrs: {
      "field": "公司简称",
      "value": _vm.customer.abbr,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "参保人数",
      "value": _vm.customer.socialSecurityCount,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "注册资本",
      "value": _vm.customer.regisCapi,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "实缴资本",
      "value": _vm.customer.paidCapi,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "所属行业",
      "value": _vm.customer.industry,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "注册日期",
      "value": _vm.customer.regisDate,
      "type": 'date'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "核准日期",
      "value": _vm.customer.provedDate,
      "type": 'date'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "注册地址",
      "value": _vm.customer.regisLoc,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "经营范围",
      "value": _vm.customer.scope,
      "type": 'string'
    }
  })], 1)])]) : _vm._e(), _vm.isShowPurview ? _c('div', {
    staticClass: "purview-info"
  }, [_c('div', {
    staticClass: "title-wrap"
  }, [_c('h3', [_vm._v("权限与状态")]), _c('div', {
    staticStyle: {
      "color": "#858585",
      "cursor": "pointer"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.EditCustomerPurviewDrawer.openDrawer(_vm.customer);
      }
    }
  }, [_vm._v(" 编辑 ")])]), _c('div', {
    staticClass: "basic-info"
  }, [_c('CustomerBasicInfoRow', {
    attrs: {
      "field": "所属部门",
      "value": _vm.customer.department,
      "type": 'object'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "开发人员",
      "value": _vm.customer.devSales,
      "type": 'array'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "维护人员",
      "value": _vm.customer.maintainSales,
      "type": 'array'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "回款人员",
      "value": _vm.customer.paymentSales,
      "type": 'array'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "销售可见",
      "value": _vm.customer.salesVisibleMember,
      "type": 'array'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "技术可见",
      "value": _vm.customer.techVisibleMember,
      "type": 'array'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "评分",
      "value": _vm.customer.rating,
      "type": 'string'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "状态",
      "value": _vm.customer.status,
      "type": 'status'
    }
  }), _c('CustomerBasicInfoRow', {
    attrs: {
      "field": "允许开发",
      "value": _vm.customer.allowDev,
      "type": 'dev'
    }
  })], 1)]) : _vm._e()]), _c('div', {
    staticClass: "table-info"
  })])]), _c('div', {
    staticClass: "list-wrap"
  }, [_vm.isShowReceiveList ? _c('div', {
    staticClass: "receive-list-wrap list-box"
  }, [_c('div', {
    staticClass: "receive-list list"
  }, [_c('Receive', {
    ref: "Receive"
  }), _c('router-view')], 1)]) : _vm._e(), _vm.isShowCustomerDevelopList ? _c('div', {
    staticClass: "customerDevelop-list-wrap list-box"
  }, [_c('div', {
    staticClass: "customerDevelop-list list"
  }, [_c('CustomerDevelopPage', {
    ref: "CustomerDevelopPage"
  }), _c('router-view')], 1)]) : _vm._e(), _vm.isShowSalesList ? _c('div', {
    staticClass: "sales-list-wrap list-box"
  }, [_c('div', {
    staticClass: "sales-list list"
  }, [_c('Sales', {
    ref: "Sales"
  }), _c('router-view')], 1)]) : _vm._e()])])]), _c('EditCustomerDetailDrawer', {
    ref: "EditCustomerDetailDrawer"
  }), _c('EditCustomerPurviewDrawer', {
    ref: "EditCustomerPurviewDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }